export default __webpack_public_path__ + "static/media/add-card.5da176c4.mp3";